var map = {
	"./chips_1.png": 7707,
	"./chips_10.png": 9076,
	"./chips_100.png": 6498,
	"./chips_1000.png": 2798,
	"./chips_10000.png": 5975,
	"./chips_100000.png": 3074,
	"./chips_5.png": 3004,
	"./chips_50.png": 9867,
	"./chips_500.png": 5500,
	"./chips_5000.png": 6147,
	"./chips_50000.png": 7465,
	"./chips_Infinity.png": 8503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6937;